import { constructFromSymbol } from "date-fns/constants";
import { jwtDecode } from "jwt-decode";
import React from "react";
import { Navigate } from "react-router-dom";

const decodeToken = (token) => {
  try {
    return jwtDecode(token);
  } catch (error) {
    return null;
  }
};

const ProtectedAdminRoute = ({ allowedRoles, element, ...rest }) => {
  const token = localStorage.getItem("coyote-token");
  if (!token) {
    return <Navigate to="/user/auth/sign-in" />;
  }
  const decodedToken = decodeToken(token);
  const allowedRolesArray = Object.values(allowedRoles);
  if (
    allowedRolesArray &&
    !allowedRolesArray?.some((role) =>
      decodedToken?.user?.roles?.some((userRole) => userRole.role_type === role)
    )
  ) {
    return <Navigate to="/dashboard" />;
  }

  return element;
};

export default ProtectedAdminRoute;
